import React from "react";
import "../projects.css";
import Timeline from "../timeline/snapperTimeline";
import "bootstrap/dist/css/bootstrap.min.css";

function Snapper() {
  return (
    <div className="project-container">
      {/* Hero Banner */}
      <div className="banner">
        <img
          src="assets/projects/Snapper-banner.png"
          alt="Snapper Project"
          className="banner-image"
        />
      </div>

      {/* Project Header */}
      <div className="project-header">
        <h1 className="project-title">Snapper</h1>
        <p className="project-subtitle">A social scuba diving app connecting divers through virtual dive logging and marine life reporting</p>
        <div className="badge-container">
          <span className="badge">UI/UX Design</span>
          <span className="badge">Prototyping</span>
          <span className="badge">User Research</span>
          <span className="badge">Figma</span>
        </div>
      </div>

      {/* Overview Section - 3 Columns */}
      <div className="project-overview">
        <div className="overview-3col">
          <div className="overview-col-item">
            <div className="overview-icon">👥</div>
            <h3 className="overview-title">My Role</h3>
            <p className="overview-text">
              As part of a 4 person design team, I contributed to mid fidelity prototypes, designed the final flow for creating posts, and developed the fish tagging feature that enables users to identify and log marine life.
            </p>
          </div>

          <div className="overview-col-item">
            <div className="overview-icon">⏱️</div>
            <h3 className="overview-title">Timeline</h3>
            <p className="overview-text">
              One semester collaborative project with a team of 4 designers. Focused on user research, iterative prototyping, and creating a cohesive brand identity.
            </p>
          </div>

          <div className="overview-col-item">
            <div className="overview-icon">✨</div>
            <h3 className="overview-title">Key Contributions</h3>
            <ul className="overview-list">
              <li>Designed onboarding and registration flow</li>
              <li>Created post creation workflow</li>
              <li>Developed fish tagging and identification feature</li>
              <li>Contributed to brand identity and visual design</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Problem Statement Section */}
      <div className="case-study-section">
        <h2 className="section-title">The Problem</h2>
        <div className="case-study-content">
          <p className="case-study-text">
            The scuba diving community lacks a centralized platform where divers can share their experiences, photos, and discoveries in one place. After years of experience in the diving community, our client identified a significant gap: there's no unified way for casual but social scuba divers and marine life enthusiasts to connect, share their finds, and learn together.
          </p>
          <p className="case-study-text">
            Existing solutions are fragmented. Divers use multiple apps and platforms that don't connect, making it difficult to build community or learn from others' experiences. There's a high demand for a platform that is both <strong>engaging and educational</strong>, allowing users to share their discoveries while learning about marine ecosystems around them.
          </p>
          <div className="brand-values">
            <h3 className="brand-values-title">Brand Values</h3>
            <div className="values-grid">
              <div className="value-item">
                <span className="value-icon">📚</span>
                <div className="value-content">
                  <strong>Educational</strong>
                  <span className="value-text">Users learn about marine ecosystems and marine life around them and around the world.</span>
                </div>
              </div>
              <div className="value-item">
                <span className="value-icon">✨</span>
                <div className="value-content">
                  <strong>Usable</strong>
                  <span className="value-text">Buttery smooth experience, seamless without relying on third party sites.</span>
                </div>
              </div>
              <div className="value-item">
                <span className="value-icon">🎨</span>
                <div className="value-content">
                  <strong>Beautiful & Clean</strong>
                  <span className="value-text">Pleasing to the eye without being cluttered, relating back to usability.</span>
                </div>
              </div>
              <div className="value-item">
                <span className="value-icon">👥</span>
                <div className="value-content">
                  <strong>Communal</strong>
                  <span className="value-text">Users can freely interact with other divers and their content.</span>
                </div>
              </div>
              <div className="value-item">
                <span className="value-icon">😊</span>
                <div className="value-content">
                  <strong>Satisfaction</strong>
                  <span className="value-text">Users feel satisfied when collecting fish tags or learning about ecosystems.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Timeline Section */}
      <div className="project-timeline-section">
        <Timeline />
      </div>

    </div>
  );
}

export default Snapper;
